export interface CancelPayLinkTarget {
    transactionId: string;
    amountMinor: number;
    payUrl: string | undefined;
    cancelling: boolean;
}

export const cancelPayLinkDialogInitialState = {
    target: undefined as CancelPayLinkTarget | undefined,
};

export type CancelPayLinkDialogState = typeof cancelPayLinkDialogInitialState;
